import { MdOutlineSyncAlt, MdPerson } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';

const Header = (props: { companyInfos: any; haveMultipleSupliers: any }) => {
    const { companyInfos, haveMultipleSupliers } = props;
    const params = useParams();

    const nav = useNavigate();

    return (
        <div className="flex items-center bg-white rounded-b-xl min-h-[60px]">
            {/* Left: logo + contact */}
            <div className="flex items-center gap-4 min-w-0 flex-1">
                {companyInfos && companyInfos.logo && (
                    <img
                        src={companyInfos.logo}
                        alt="logo"
                        className="ml-2 max-w-[140px] sm:max-w-[200px] max-h-[50px] object-contain flex-shrink-0"
                    />
                )}
                {companyInfos && companyInfos.contact && (
                    <div className="text-[11px] text-navy-700 hidden sm:block">
                        <p className="font-bold">Contact:</p>
                        <p>{companyInfos.contact}</p>
                    </div>
                )}
            </div>

            {/* Right: customer name + action buttons */}
            <div className="flex items-center gap-2 flex-shrink-0 pr-1">
                {companyInfos?.customerCompany && (
                    <p className="text-xs sm:text-sm text-gray-600 font-medium truncate max-w-[80px] sm:max-w-[160px] lg:max-w-[260px]">
                        {companyInfos.customerCompany}
                    </p>
                )}
                {haveMultipleSupliers && params.v && (
                    <div className="border rounded-xl p-1 hover:cursor-pointer hover:bg-gray-100 flex-shrink-0">
                        <MdOutlineSyncAlt
                            size={20}
                            onClick={() => nav(`/portal/${params.v}${window.location.search}`)}
                        />
                    </div>
                )}
                <div className="border rounded-xl p-1 hover:cursor-pointer hover:bg-gray-100 flex-shrink-0">
                    <MdPerson size={20} onClick={() => nav(`/command/account${window.location.search}`)} />
                </div>
            </div>
        </div>
    );
};

export default Header;
